function Published2020() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-1/6 text-center">2020</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-full">
                        <p>Ilves, Jesper, et al. (the 5th author), <a href="https://www.nature.com/articles/s41534-020-0266-4" target="_blank" className="text-sky-600">“On-demand generation and characterization of a microwave time-bin qubit.”</a></p>
                        <p>npj Quantum Information 6.1 (2020): 1-7.</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-full">
                        <p>R. Yano and M. Kim, <a href="https://iopscience.iop.org/article/10.1088/2399-6528/ab6e61" target="_blank" className="text-sky-600">“Topological analysis of pattern formation in cooling granular gases confinded by elastic wall.”</a></p>
                        <p>Journal of Physics Communications (2020): 015023. (42 pages)</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Published2020;